<template>
  <div>
    <button
      class="tw-p-3 tw-cursor-pointer tw-bg-white tw-shadow-sm tw-rounded-lg tw-text-[#F1583D] tw-flex tw-items-center tw-font-medium tw-whitespace-nowrap tw-border tw-border-solid tw-border-[#DFE2E7]"
      @click="isBenchmarkCreationModalActive = true"
    >
      <i class="fas fa-plus tw-mr-2" />
      Create benchmark
    </button>
    <o-modal
      :active.sync="isBenchmarkCreationModalActive"
      content-class="tw-h-1/2 tw-w-1/2"
    >
      <PortfolioCreator @submit="setBenchmarkFromCreator" />
    </o-modal>
  </div>
</template>


<script>
import PortfolioCreator from '@frontend/ui/components/utils/PortfolioCreator.vue';
import { useCheckupStore } from '@frontend/ui/stores/checkupStore';
import { mapStores } from 'pinia';

export default {
  name: 'ComponentName',
  components: { PortfolioCreator },
  props: [/* Inputs */],
  data() {
    return {
      isBenchmarkCreationModalActive: false,
    };
  },
  computed: {
    ...mapStores(useCheckupStore),

  },
  watch: { /*
      Watches an existing property
      Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  updated() {},
  methods: {
    setBenchmarkFromCreator(newBenchmark) {
      console.log('setBenchmarkFromCreator: newBenchmark', newBenchmark);
      this.checkupStore.removePortfolio(this.checkupStore.benchmark);
      this.checkupStore.setBenchmark(newBenchmark);
      this.isBenchmarkCreationModalActive = false;
    },
  },
};
</script>


  <style scoped>

  </style>
